import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'
import type { FilterCatalogFormMode } from '../the-consumer-market/tcm_scopes'
import type { MercadoVetPresenter } from './mv_presenter'

export type MercadoVetTab = 'cnpj' | 'web' | 'linkedin'

const TABS: MercadoVetTab[] = ['cnpj', 'web', 'linkedin']

const presenterUUID = '5c1e0b7a94d2'

export class MercadoVetKeys extends MainKeys {
    get place() {
        return Places.mercadoVet
    }

    get tab(): MercadoVetTab {
        const value = this._intent.getParameterAsString(ParamIds.mvTab) as MercadoVetTab
        return TABS.includes(value) ? value : 'cnpj'
    }

    set tab(value: MercadoVetTab | undefined) {
        this._intent.setParameter(ParamIds.mvTab, value && value !== 'cnpj' ? value : undefined)
    }

    get mvPresenter() {
        return this._intent.attributes.get(presenterUUID) as MercadoVetPresenter
    }

    set mvPresenter(value: MercadoVetPresenter) {
        this._intent.attributes.set(presenterUUID, value)
    }
}

export class MvFilterCatalogFormKeys extends MercadoVetKeys {
    get place() {
        return Places.mercadoVet_FilterCatalogForm
    }

    setMode(mode: FilterCatalogFormMode) {
        this._intent.setParameter(ParamIds.tcmFilterFormMode, mode)
        return this
    }

    get mode(): FilterCatalogFormMode {
        return (this._intent.getParameterAsString(ParamIds.tcmFilterFormMode) ?? 'create') as FilterCatalogFormMode
    }

    setSourceId(id: string) {
        this._intent.setParameter(ParamIds.tcmFilterSourceId, id)
        return this
    }

    get sourceId(): string {
        return this._intent.getParameterAsString(ParamIds.tcmFilterSourceId) ?? ''
    }
}

export class MvFilterCatalogShareKeys extends MercadoVetKeys {
    get place() {
        return Places.mercadoVet_FilterCatalogShare
    }

    setSourceId(id: string) {
        this._intent.setParameter(ParamIds.tcmFilterSourceId, id)
        return this
    }

    get sourceId(): string {
        return this._intent.getParameterAsString(ParamIds.tcmFilterSourceId) ?? ''
    }
}

export default MercadoVetKeys
